import { render, staticRenderFns } from "./GroupSeat.vue?vue&type=template&id=8a4c6c56"
import script from "./GroupSeat.vue?vue&type=script&lang=js"
export * from "./GroupSeat.vue?vue&type=script&lang=js"
import style0 from "./GroupSeat.vue?vue&type=style&index=0&id=8a4c6c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports